"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.value = void 0;
const error = function (err) {
    return {
        hasError() {
            return true;
        },
        hasValue() {
            return false;
        },
        unwrapOrThrow() {
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw err;
        },
        unwrapOrElse(handleError) {
            return handleError(err);
        },
        unwrapOrDefault(defaultValue) {
            return defaultValue;
        },
        error: err
    };
};
exports.error = error;
const value = function (val) {
    return {
        hasError() {
            return false;
        },
        hasValue() {
            return true;
        },
        unwrapOrThrow() {
            return val;
        },
        unwrapOrElse() {
            return val;
        },
        unwrapOrDefault() {
            return val;
        },
        value: val
    };
};
exports.value = value;
